import React from 'react';
import './FeeStructure.css';
import { BadgePercent, CreditCard, IndianRupee } from 'lucide-react';

const FeeStructure = () => {
  return (
    <section className="fee-structure-section">
      <div className="fee-structure-wrapper">
        <h2 className="fee-structure-heading">Fee Structure</h2>
        <p className="fee-structure-subheading">Affordable and flexible payment options to suit every learner.</p>

        <div className="fee-structure-cards">
          <div className="fee-structure-card">
            <div className="fee-structure-icon-box fee-structure-normal">
              <IndianRupee size={28} />
            </div>
            <h3 className="fee-structure-title">Normal Price</h3>
            <p className="fee-structure-price">₹24,999</p>
            <p className="fee-structure-desc">Full access to all modules, resources, and lifetime community support.</p>
          </div>

          <div className="fee-structure-card fee-structure-highlight">
            <div className="fee-structure-icon-box fee-structure-offer">
              <BadgePercent size={28} />
            </div>
            <h3 className="fee-structure-title">Offer Price</h3>
            <p className="fee-structure-price fee-structure-discounted">₹14,999</p>
            <p className="fee-structure-desc">Limited time offer. Save ₹10,000! Valid until <strong>August 31st</strong>.</p>
          </div>

          <div className="fee-structure-card">
            <div className="fee-structure-icon-box fee-structure-emi">
              <CreditCard size={28} />
            </div>
            <h3 className="fee-structure-title">EMI Options</h3>
            <p className="fee-structure-price">Starts from ₹1,499/month</p>
            <p className="fee-structure-desc">Pay in easy installments via credit/debit cards or UPI-linked wallets.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeeStructure;
